import {
  convertEmToPixel,
  convertPixelToEm,
  getNumericFontValue,
  wrapFontFamilyInQuotes,
} from 'content-creation-common/utils/font';

import {
  ALTERNATE_FONT_PREVIEW_SET,
  DEFAULT_FONT_SIZE,
} from '../features/text/constants';

import { isNotNil } from './object';

export {
  convertEmToPixel,
  convertPixelToEm,
  getNumericFontValue,
  wrapFontFamilyInQuotes,
};

export const filterInvalidFonts = (fonts) =>
  fonts.filter((font) => font.psName);

export const getFontPreviewUrl = (font, fontPreviewSet) => {
  const previewUrl = `/api/v1/fonts2/${encodeURIComponent(font.id)}/preview`;
  return fontPreviewSet ? `${previewUrl}?set=${fontPreviewSet}` : previewUrl;
};

export const getFontDisplayName = (psName, fonts) => {
  const font = fonts.find((font) => font.psName === psName);
  return isNotNil(font) ? font.displayName : psName;
};

export const loadFontPreview = (font) => {
  const previewImage = new Image();
  previewImage.src = getFontPreviewUrl(font);

  const previewAltImage = new Image();
  previewAltImage.src = getFontPreviewUrl(font, ALTERNATE_FONT_PREVIEW_SET);
};

export const getScaledFontSize = (
  fontSize = DEFAULT_FONT_SIZE,
  scaleFactor,
) => {
  return Math.floor(getNumericFontValue(fontSize) * scaleFactor);
};

export const getScaledFontPadding = (padding, fontAdjustment, scaleFactor) => {
  return Math.floor((padding + fontAdjustment) * scaleFactor);
};
